/**
 * The list of menu items
 * @param t
 */
const getNavs = t => ({
  items: [
    {
      divider: true,
    },
    {
      title: true,
      name: '',
    },
    {
      name: t('Dashboard'),
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: t('Translations'),
      url: '/translations',
      icon: 'icon-pencil',
      permissions: ['read_translations'],
    },
    {
      name: t('Users'),
      url: '/users',
      icon: 'icon-user',
      permissions: ['read_users', 'read_roles', 'read_feedback'],
      children: [
        {
          name: t('Users'),
          url: '/users/index',
          icon: 'icon-people',
          permissions: ['read_users'],
        },
        {
          name: t('Companies'),
          url: '/users/companies',
          icon: 'fa fa-building',
          permissions: ['read_companies'],
        },
        // {
        //   name: t('Roles'),
        //   url: '/users/roles',
        //   icon: 'icon-lock',
        //   permissions: ['read_roles'],
        // },
        // {
        //   name: t('Feedback'),
        //   url: '/users/feedback',
        //   icon: 'icon-envelope',
        //   permissions: ['read_feedback'],
        // },
      ],
    },
    {
      name: t('licenses'),
      url: '/licenses',
      icon: 'icon-star',
      permissions: ['read_licenses'],
    },
    {
      name: t('Languages'),
      url: '/languages',
      icon: 'icon-flag',
      permissions: ['read_languages'],
    },
    {
      name: t('Notifications'),
      url: '/notifications',
      icon: 'fa fa-star',
      permissions: ['read_animations'],
    },
    {
      name: t('Animations lists'),
      url: '/animations-lists',
      icon: 'fa fa-star',
      permissions: ['read_animations'],
    },
    {
      name: t('Fonts'),
      url: '/fonts',
      icon: 'fa fa-font',
      permissions: ['read_animations'],
    },
    {
      name: t('Videos'),
      url: '/videos',
      icon: 'fa fa-play',
      permissions: ['read_animations'],
    },
    {
      name: t('Settings'),
      url: '/settings',
      icon: 'icon-settings',
      permissions: ['read_settings'],
    },
    {
      divider: true,
    },
    {
      name: t('Logout'),
      url: '/logout',
      icon: 'icon-logout',
    },
  ],
});

/**
 * This function filter the array of menu items by permissions
 * @param items
 * @param permissions
 */
const filterItems = (items, permissions) => {
  return items.filter((root) => {
    if (!root.permissions) return true;
    if (root.permissions && root.permissions.length > 0) {
      for (const permission of root.permissions) {
        if (permissions.includes(permission)) return true;
      }
      return false;
    }
    return true;
  });
};

/**
 * This function filter the menu items tree by permissions
 * @param t
 * @param permissions
 */
export default (t, permissions) => {
  const navs = getNavs(t);
  navs.items = filterItems(navs.items, permissions);
  for (let i = 0; i < navs.items.length; i += 1) {
    if (navs.items[i].children && navs.items[i].children.length > 0) {
      navs.items[i].children = filterItems(navs.items[i].children, permissions);
    }
  }
  return navs;
};




// WEBPACK FOOTER //
// ./src/_nav.js